const t = {
  "⌘": "Command",
  "^": "Control",
  ctrl: "Control",
  "⌥": "Option",
  alt: "Alt",
  "⇧": "Shift",
  "⇪": "Caps Lock",
  "↵": "Enter",
  "←": "Left Arrow",
  "→": "Right Arrow",
  "↑": "Up Arrow",
  "↓": "Down Arrow"
}, o = {
  Meta: "⌘",
  Shift: "⇧",
  Alt: "⌥",
  Control: "^"
}, r = {
  Meta: "ctrl",
  Shift: "⇧",
  Alt: "alt",
  Control: "ctrl"
};
export {
  t as HOTKEY_LABELS,
  r as MODIFIER_KEY_SYMBOLS,
  o as MODIFIER_KEY_SYMBOLS_MACOS
};
